module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"ui":{"components":{"users":{"tile":{"goto_user":"Profil anzeigen","send_message":"Nachricht senden"}}}}}}')
  delete Component.options._Ctor
}
